var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0 justify-center mt-6",attrs:{"dense":""}},[_c('v-col',{staticClass:"text-center pt-6",attrs:{"cols":"12"}},[_c('h1',[_vm._v(_vm._s(_vm.$vuetify.lang.t('$vuetify.loading')))]),_c('v-progress-circular',{staticClass:"mt-4",attrs:{"indeterminate":"","color":"var(--primary-alternative)"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }